import { TableColumns } from "../../../../core/models/dashboard/tableColumns";

export const columns: TableColumns[] = [
  {
    header: "CB Days",
    field: "cbDays",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Invoice",
    field: "invoice",
    link: true,
    linkField: "invoice",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Client",
    field: "client",
    link: true,
    linkField: "clientId",
    isDate: false,
    isNumber: false,
  },
  {
    header: "Job Name",
    field: "jobName",
    link: true,
    linkField: "salesId",
    isDate: false,
    isNumber: false,
    isLongValueTrimmed: true,
  },
  {
    header: "Total Amt",
    field: "totalAmount",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Open Amt",
    field: "openAmount",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
  {
    header: "Payments",
    field: "payments",
    link: false,
    linkField: "",
    isDate: false,
    isNumber: true,
  },
];
